import { EWalletId } from '@ankr.com/provider';
import type { NotificationPayload } from '@ankr.com/auth';
import { useEffect } from 'react';

import { APIGateways } from 'modules/auth/const';
import {
  setAuthAddress,
  setAuthProvider,
  setAuthToken,
  setAuthTokenExpiresAt,
  setIsMarketingAccepted,
  setIsSignedIn,
  setReferralCode,
  setWalletId,
} from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';

export const useAuthDataSubscriber = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const listener = ({
      authAddress,
      authProvider,
      expiresAt,
      isMarketingAccepted,
      isSignedIn,
      referralCode,
      token,
      walletId,
    }: NotificationPayload) => {
      dispatch(setAuthAddress(authAddress));
      dispatch(setAuthProvider(authProvider));
      dispatch(setAuthToken(token));
      dispatch(setAuthTokenExpiresAt(expiresAt));
      dispatch(setIsSignedIn(isSignedIn));
      dispatch(setReferralCode(referralCode));
      dispatch(setWalletId(walletId as EWalletId | undefined));
      if (isMarketingAccepted) {
        dispatch(setIsMarketingAccepted(isMarketingAccepted === 'true'));
      } else {
        dispatch(setIsMarketingAccepted(undefined));
      }
    };

    APIGateways.auth.addListener(listener);

    return () => {
      APIGateways.auth.removeListener(listener);
    };
  }, [dispatch]);
};
